module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchPage"
  }, [_c('Waiting'), _vm._v(" "), _c('Navigation', {
    attrs: {
      "showUserNav": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 SearchOptions m-t-4 p-r-3"
  }, [_c('SearchBar', {
    attrs: {
      "orientation": "vertical",
      "showTitle": true
    },
    on: {
      "search": function($event) {
        _vm.searchLocal()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "searchResults row m-t-2"
  }, [(_vm.activities.length > 0) ? _c('div', {
    staticClass: "displayOptions m-b-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setView('grid')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setView('list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activities), function(activity) {
    return _c('div', {
      staticClass: "activityCardContainer",
      class: {
        grid: (_vm.cardSize === 'small'), list: (_vm.cardSize === 'large')
      }
    }, [_c('router-link', {
      staticClass: "activityLink",
      attrs: {
        "to": '/' + _vm.language + '/activity/' + activity.slug
      }
    }, [_c('ActivityCard', {
      staticClass: "sameHeight",
      attrs: {
        "activity": activity,
        "size": _vm.cardSize
      }
    })], 1)], 1)
  }), _vm._v(" "), (!_vm.activities.length && !_vm.loading) ? _c('div', {
    staticClass: "noResults m-t-3"
  }, [_c('h2', {
    staticClass: "m-b-2"
  }, [_vm._v(_vm._s(_vm.t('Sorry no activities were found for your search query.')))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": ("/" + _vm.language)
    }
  }, [_vm._v(_vm._s(_vm.t('go back')))])], 1) : _vm._e()], 2)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30d68335", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d68335"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/Search.vue
// module id = 770
// module chunks = 3